import gql from 'graphql-tag'

export default gql`mutation ($data: UserRoleHourlyRatesInput, $user_role_id: Int!, $update_timesheets: Boolean) {
  createUserRoleHourlyRate(data: $data, user_role_id: $user_role_id, update_timesheets: $update_timesheets) {
    user_role_id
    description
    permissions{
	  permission_id
      access
    }
    hourly_rates{
      role_daily_rate_id
      day_value_id
      day_value{
        day_value_id
        day_name
        abbreviated_name
      }
      hourly_rate
      date_active
    }
  }
}`